import { Pipe, PipeTransform } from '@angular/core';
import { truncateHtml } from '@shared/utils';

@Pipe({
  name: 'truncateHtml',
  standalone: true,
})
export class TruncateHtmlPipe implements PipeTransform {
  transform(value: string, limit = 128): string {
    if (!value) return '';

    return truncateHtml(value, limit);
  }
}
